import React from "react";
import ReturnButton from "./ReturnButton";

export default function Download() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <ReturnButton />
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-xl w-full text-center">
        <h1 className="text-3xl font-bold mb-4">Télécharger l’extension V-repop</h1>
        <p className="mb-6 text-gray-700">
          Pour profiter de la republication automatique, téléchargez l’extension Chrome officielle.
        </p>
        <a
          href="#"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition"
        >
          Télécharger l’extension Chrome
        </a>
        <p className="mt-4 text-sm text-gray-500">
          L’extension est compatible uniquement avec Google Chrome et Brave.
        </p>
      </div>
    </div>
  );
}
